import { create } from 'zustand';

const useGameStore = create((set, get) => ({
  isGameLoaded: false,
  setGameLoaded: (isGameLoaded) => set(() => ({ isGameLoaded })),
}));

export default useGameStore;
